export default {
  dataRetention: '',
  resetPwdDone: false,
  token: null,
  user: ''
}



// WEBPACK FOOTER //
// ./src/store/state.js